import { render, staticRenderFns } from "./TradeAnalyticStats.vue?vue&type=template&id=5702acdc&"
import script from "./TradeAnalyticStats.vue?vue&type=script&lang=js&"
export * from "./TradeAnalyticStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports